module.exports = __webpack_public_path__ + "img/5-1.9cbedf30.png";